import { render, staticRenderFns } from "./GerarRelatorioCaptacao.vue?vue&type=template&id=4a8f4496&scoped=true&"
import script from "./GerarRelatorioCaptacao.vue?vue&type=script&lang=js&"
export * from "./GerarRelatorioCaptacao.vue?vue&type=script&lang=js&"
import style0 from "./GerarRelatorioCaptacao.vue?vue&type=style&index=0&id=4a8f4496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8f4496",
  null
  
)

export default component.exports